<!--日生产计划成品-->
<template>

  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <!-- <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.vendorCode"
                selectType="select"
                requestApi="/scp/scpProductionScheduling/listSupplier"
                :selectItem="{ value: 'realValue', label: 'label' }"
              /> -->
              <global-select
                v-decorator="['vendorCode']"
                :value.sync="queryParams.vendorCode"
                selectType="selectSearch"
                searchParam="supplier"
                :allowClear="organizationCodeOrigin==='A001'"
                :default-active-first-option="organizationCodeOrigin!=='A001'"
                requestApi="/scp/scpProductionScheduling/getSupplierList"
                :selectItem="{ value: 'supplierCode', label: 'supplierName' }"
                :setParams="{ organizationCode: organizationCodeOrigin }"
                :dropdown-match-select-width="false"
              ></global-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="交货时间">
              <a-range-picker
                :placeholder="['开始日期', '结束日期']"
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="queryParams.deliveryDateTem"
                @change="onChangeDeliveryDate" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="下单计划时间" :labelCol="{ style: { width: '110px' } }">
              <a-range-picker
                :placeholder="['开始日期', '结束日期']"
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="queryParams.issuedTimeTem"
                @change="onChangeIssuedTime" />
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="计划单号">
              <a-input v-model="queryParams.orderNumber" />
              <!-- <global-select
                :value.sync="queryParams.orderNumber"
                selectType="select"
                :setParams="{type:1}"
                requestApi="/scp/scpProductionScheduling/cpComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCode" />

              <!-- <global-select
                :value.sync="queryParams.itemCode"
                selectType="select"
                :setParams="{type:2}"
                requestApi="/scp/scpProductionScheduling/cpComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="物料名称">
              <a-input v-model="queryParams.itemName" />

              <!-- <global-select
                :value.sync="queryParams.itemName"
                selectType="select"
                :setParams="{type:3}"
                requestApi="/scp/scpProductionScheduling/cpComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="拆解标识">
              <a-select v-model="queryParams.disassembleFlag" allowClear>
                <a-select-option v-for="(item) in yesOrNoOptions" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="产线标识">
              <a-select v-model="queryParams.lineFlag" allowClear>
                <a-select-option v-for="(item) in yesOrNoOptions" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="排产标识">
              <a-select v-model="queryParams.planFlag" allowClear>
                <a-select-option v-for="(item) in yesOrNoOptions" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="计划来源">
              <a-select v-model="queryParams.planType" allowClear>
                <a-select-option v-for="(item) in planTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" v-if="advanced" :sm="24">
            <a-form-item label="状态">
              <a-select mode="multiple"
                        :max-tag-text-length="2"
                        :max-tag-count="1"
                        v-model="queryParams.planStatus"
                        allowClear>
                <a-select-option v-for="(item) in planStatusList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper display-flex" slot="btn">
      <!-- <a-button @click="handleExport" >成品</a-button> -->
      <div class="flex1"></div>
<!--      <a-button @click="handleExportT60" type="primary" v-hasPermi="['scp:finishProduct:finishProductImportWj']">T+60&预测导入</a-button>-->
      <a-dropdown v-hasPermi="['scp:finishProduct:finishProductImportWj']">
        <a-menu slot="overlay" @click="handleExportHardware">
          <a-menu-item key="2">五金箱需求导入</a-menu-item>
          <a-menu-item key="3">成品需求导入</a-menu-item>
          <a-menu-item key="1">五金箱计划单导出</a-menu-item>
        </a-menu>
        <a-button type="primary"> 五金箱 <a-icon type="down" /> </a-button>
      </a-dropdown>
      <a-button @click="handleExportTemplate" type="primary" v-hasPermi="['scp:dailyProductionPlanEndProduct:importTemplate']">导入模版</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['scp:dailyProductionPlanEndProduct:import']">导入</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:dailyProductionPlanEndProduct:export']">导出</a-button>
      <a-button :disabled="selectedRowKeys.length < 1" @click="handleDisassemble" type="primary" v-hasPermi="['scp:dailyProductionPlanEndProduct:disassemble']">拆解</a-button>
      <a-button :disabled="selectedRowKeys.length < 1" @click="handleBatchCancel" v-hasPermi="['scp:dailyProductionPlanEndProduct:cancel']" type="primary">批量取消</a-button>
      <a-button @click="handleGoSchedulingWorkbench" type="primary" v-hasPermi="['scp:dailyProductionPlanEndProduct:goWorkbench']">排产工作台</a-button>
      <a-button v-hasPermi="['external:plm:getSignBom']" @click="handleSynchronous" type="primary" :loading="btnLoading">下载签价BOM</a-button>
      <a-button v-hasPermi="['external:plm:manualSyncMaterial']" @click="openMaterialSyncModal" type="primary">物料同步</a-button>
      <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="uploadT60" :uploadAboutRequest="uploadAboutRequest" :customizeUpload="true" @refresh="onSearch" />
      <import-excel ref="hwImportExcelRef" :downloadParams="hwDownloadParams" :uploadAboutRequest="hwUploadAboutRequest" :customizeUpload="true" @refresh="onSearch" />
      <!-- 物料同步弹窗 -->
      <a-modal
        title="手动物料同步"
        :visible="materialSyncVisible"
        @ok="handleMaterialSync"
        :confirmLoading="confirmLoading"
        @cancel="handleMaterialSyncCancel"
      >
        <a-form-model
          ref="materialSyncFormRef"
          :model="materialSyncForm"
          :rules="materialSyncRules"
          layout="vertical"
        >
          <a-form-model-item label="物料编码/签价单号" prop="code">
            <a-input v-model="materialSyncForm.code" placeholder="请输入物料编码" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @successCallBack="successCallBack"
          @selectedRowChange="selectedRowChange"
          rowKey="orderNo"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.END_PRODUCT_LIST, // 表格方案配置唯一值
              }"
        >
          <!--大货类型，状态已下发不能编辑-->
          <template slot="bigGoodsTypeValue" slot-scope="{ record }">
            <global-select
              v-if="isEdit && currentId === record.orderNumber && record.planStatus !== 'ISSUED'"
              :value.sync="record.bigGoodsType"
              selectType="select"
              :allowClear="false"
              :selectData="bigGoodsList"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
            <span v-else>{{ record.bigGoodsTypeValue }}</span>
          </template>
          <template slot="disassembleFlag" slot-scope="{ record }">
            <span>{{ record.disassembleFlag }}</span>
          </template>
          <template slot="deliveryDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="issuedTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.orderNumber" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
          </template>
          <template slot="vendorCode" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.orderNumber">{{ text }}</span>
            <global-select
              v-if="isEdit && currentId === record.orderNumber"
              :value.sync="record.vendorCode"
              size="small"
              selectType="selectAssembleSearch"
              :allow-clear="false"
              requestApi="/scp/scpProductionScheduling/skuSupplierBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ itemId: record.itemId }"
              sourseField="res"
              :dropdown-match-select-width="false"
              @change="(val, selectList) => handleVendorCodeSelectChange(val, selectList, record)"
            />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="(record.planFlag === 'N' && record.disassembleFlag === 'Y') && (!isEdit || currentId !== record.orderNumber)" @click="handleEdit(record)" v-hasPermi="['mdm:mdmUomConversions:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.orderNumber" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.orderNumber" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :customRequest="customUpload"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>

    </template>
  </ls-table-layout>

</template>

  <script>
  import {
    apiFinishProductSearchList,
    apiScpProductionSchedulingDisassembly2,
    apiScpProductionSchedulingFinishProductUpdate,
    apiScpDelfinishProduct,
    apiFinishProductImport,
    apiMdmGetSignBom,
    apiManualSyncMaterial
  } from '@/api/scp/dailyProductionPlan/dailyProductionPlan'
  import { generateLsTableResData } from '@/utils/util.js';
  import Cookies from 'js-cookie';
  import cacheRequest from '@/mixins/cacheRequest'
  import { parseResFileOrJson, METHOD, requestSet } from '@/utils/request'
  import cloneDeep from 'lodash.clonedeep'
  import ImportExcel from "@/views/finished-goods-order/base-data/supplier-process-ranking/components/importExcel"
  import moment from 'moment'
  import { mapState } from 'vuex'
  export default {
    name: 'EndProduct',
    components: {
      ImportExcel
    },
    mixins: [cacheRequest],
    computed: {
      ...mapState({
        organizationCodeOrigin: (state) => state.user.organizationCode
      })
    },
    data () {
      const token = process.env.NODE_ENV === "development" ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
      return {
      btnLoading: false, // 按钮loading
      confirmLoading: false, // 确认loading
      mode: ['month', 'month'],
      // 用户导入参数
      uploadT60: {
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpProductionScheduling/finishProductImportWj' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'scp/scpProductionScheduling/templateWj',
        name: `T+60&预测导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
        uploadAboutRequest: {
          requestApi: '',
          errFileName: 'T+60&预测导入异常.xlsx'
        },
        hwDownloadParams: {
          method: 'post',
          url: 'scp/scpProductionScheduling/importTemplateWjxHardBox',
          name: `五金箱导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
        },
        hwUploadAboutRequest: {
          requestApi: (params) => { return requestSet(`/scp/scpProductionScheduling/importDataFpWjxHardBox`, METHOD.POST, params, { responseType: "blob" }); },
          errFileName: '五金箱导入异常.xlsx'
        },
      // 导入excel
      excelVisible: false,
      // 物料同步弹窗
      materialSyncVisible: false,
      materialSyncForm: {
        code: ''
      },
      materialSyncRules: {
        code: [
          { required: true, message: '物料编码不能为空', trigger: 'change' }
        ]
      },
        bigGoodsList: [], // 大货快码列表
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpProductionScheduling/finishProductImport'
      },
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiFinishProductSearchList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        planTypeList: [], // 计划来源
        planStatusList: [], // 状态
        // 默认选择状态：FAIL不通过、FIRST_FIVE_PIECE_FAIL首五件未通过，FIRST_PIECE_FAIL首件未通过，INITIAL未下发，BIG_GOODS_FAIL大货改善未通过
        defaultPlanStatusList: ['FAIL', 'FIRST_FIVE_PIECE_FAIL', 'FIRST_PIECE_FAIL', 'INITIAL', 'BIG_GOODS_FAIL'],
        // 查询参数
        queryParams: {
          vendorCode: undefined, // 供应商
          deliveryDateTem: undefined, // 交货时间临时
          deliveryDate1: undefined, // 交货时间起
          deliveryDate2: undefined, // 交货时间结束
          issuedTimeTem: undefined, // 计划单下达时间
          issuedTime1: undefined, // 计划单下达时间1
          issuedTime2: undefined, // 计划单下达时间2
          orderNumber: undefined, // 计划单号
          itemCode: undefined, // 物料编码
          itemName: undefined, // 物料名称
          planStatus: [], // 状态，改成list,接口入参用逗号拼接
          planType: undefined // 计划来源
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
          {
            title: '计划单主号',
            dataIndex: 'orderNumber',
            stickyFixed: 'left',
            align: 'center',
            width: 130
          },
         {
            title: '计划单号',
            stickyFixed: 'left',
            dataIndex: 'orderNo',
            align: 'center',
            width: 130
          },
          {
            title: '状态',
            stickyFixed: 'left',
            dataIndex: 'planStatusValue',
            align: 'center',
            width: 100
          },
          {
            title: '大货类型',
            dataIndex: 'bigGoodsTypeValue',
            align: 'center',
            scopedSlots: { customRender: 'bigGoodsTypeValue' },
            width: 110
          },
          {
            title: '系统匹配值(大货类型)',
            dataIndex: 'systemBigGoodsTypeValue',
            align: 'center',
            width: 110
          },
          {
            title: '计划来源',
            dataIndex: 'planTypeValue',
            align: 'center',
            width: 110
          },
          {
            title: '供应商',
            dataIndex: 'vendorCode',
            scopedSlots: { customRender: 'vendorCode' },
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '供应商简称',
            dataIndex: 'supplierName',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '库存组织',
            dataIndex: 'orgName',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '来源MPS单号',
            dataIndex: 'mpsNo',
            width: 160,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '物料编码',
            dataIndex: 'itemCode',
            width: 160,
            scopedSlots: { customRender: 'itemCode' },
            align: 'center'
          },
          {
            title: '物料名称',
            width: 120,
            dataIndex: 'itemName',
            scopedSlots: { customRender: 'itemName' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '规格描述',
            width: 120,
            dataIndex: 'description',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '交货时间',
            scopedSlots: { customRender: 'deliveryDate' },
            dataIndex: 'deliveryDate',
            align: 'center',
            width: 160
          },
          {
            title: '单位',
            dataIndex: 'primaryUom',
            scopedSlots: { customRender: 'primaryUom' },
            width: 150,
            align: 'center'
          },
          {
            title: '需求数量',
            width: 120,
            dataIndex: 'orderQuantity',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '项目组',
            ellipsis: true,
            width: 140,
            dataIndex: 'projectTeam',
            scopedSlots: { customRender: 'projectTeam' },
            align: 'center'
          },
          {
            title: '销售类目',
            width: 120,
            dataIndex: 'salesCategory',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '排产标识',
            dataIndex: 'planFlag',
            scopedSlots: { customRender: 'planFlag' },
            width: 150,
            align: 'center'
          },
          {
            title: '含税单价',
            dataIndex: 'linePrice',
            scopedSlots: { customRender: 'linePrice' },
            width: 150,
            align: 'center'
          },
          {
            title: '含税总价',
            dataIndex: 'sellingPrice',
            scopedSlots: { customRender: 'sellingPrice' },
            width: 150,
            align: 'center'
          },
          {
            title: '计划单下达时间',
            dataIndex: 'issuedTime',
            scopedSlots: { customRender: 'issuedTime' },
            width: 150,
            align: 'center'
          },
          {
            title: '拆解标志',
            dataIndex: 'disassembleFlag',
            width: 120,
            scopedSlots: { customRender: 'disassembleFlag' },
            align: 'center'
          },
          {
            title: '产线标识',
            dataIndex: 'lineFlag',
            width: 100,
            align: 'center'
          },
          {
            title: '拆解失败原因',
            dataIndex: 'disassembleFailReason',
            width: 150,
            align: 'center'
          },
          {
            title: '拆解失败类型',
            dataIndex: 'disassembleFailType',
            width: 150,
            align: 'center'
          },
          {
            title: '备注',
            dataIndex: 'remarks',
            scopedSlots: { customRender: 'remarks' },
            width: 150,
            align: 'center'
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            stickyFixed: 'right'
          }
          // {
          //   title: '生产时间',
          //   scopedSlots: { customRender: 'deliveryDate' },
          //   dataIndex: 'produceDate',
          //   align: 'center',
          //   width: 160
          // },
        ],
        unitOfMeasureList: [],
        unitOfMeasureListNew: [],
        yesOrNoOptions: [
          { label: '是', value: 'Y' },
          { label: '否', value: 'N' }
        ]
      }
    },
    created () {
      this.cacheLookupRequest('ORDER_TYPE', { lookupType: 'ORDER_TYPE', current: 1, pageSize: 999 }, 'bigGoodsList')
      this.getLookupList('MES_CP_PLAN_TYPE', 'planTypeList') // 计划来源快码数据
      // this.getLookupList('MES_CP_PLAN_STATUS', 'planStatusList') // 状态快码数据
    },
    mounted () {
      this.getLookupListData({ lookupType: 'MES_CP_PLAN_STATUS', current: 1, pageSize: 999 }).then().then(res => {
        this.planStatusList = res.rows
        if (this.planStatusList?.length > 0) {
          // 默认选择状态：FAIL不通过、FIRST_FIVE_PIECE_FAIL首五件未通过，FIRST_PIECE_FAIL首件未通过，INITIAL未下发，BIG_GOODS_FAIL大货改善未通过，有这些状态就添加选择
          const getData = this.planStatusList.filter(item => this.defaultPlanStatusList.includes(item.lookupCode))
          if (getData?.length > 0) {
            this.queryParams.planStatus = getData.map(item => item.lookupCode)
          }
        }
        setTimeout(() => {
          this.onSearch()
        }, 500)
      })
    },
    methods: {
      // 行选中
      selectedRowChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
      },
      // 翻页清除选择
      successCallBack() {
        if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
      },
      tableChange (pagination) {

      },
      onChangeDeliveryDate (value, mode) {
        const yearMonth1 = value[0]
      const yearMonth2 = value[1]
      this.queryParams.deliveryDate1 = yearMonth1
      this.queryParams.deliveryDate2 = yearMonth2
      this.queryParams.deliveryDateTem = value
      },
      onChangeIssuedTime (value, mode) {
        const yearMonth1 = value[0]
      const yearMonth2 = value[1]
      this.queryParams.issuedTime1 = yearMonth1
      this.queryParams.issuedTime2 = yearMonth2
      this.queryParams.issuedTimeTem = value
      },
      // 自定义上传
      async customUpload({ file, onSuccess, onError }) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        apiFinishProductImport(formData).then(res => {
          parseResFileOrJson(res, () => {
            this.onSearch(); // 重新查询
          }, '日生产计划成品导入异常.xlsx');
          onSuccess({ code: 200 }, file);
        }).finally(() => {
          // this.isUploading = false;
        })
      } catch (error) {
        onError(error);
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    // 五金箱组合按钮
    handleExportHardware(val) {
      if(val?.key === '3') {
        this.handleExportT60()
      }else if(val?.key === '2') {
        this.$refs.hwImportExcelRef.show()
      }else if(val?.key === '1') {
        this.handleExport('wj')
      }else {
        this.$message.warning('请检查按钮key值')
      }
    },
    // T+60&预测导入
    handleExportT60() {
      const apiImportPlanOrder = (params) => {
        return requestSet(`/scp/scpProductionScheduling/finishProductImportWj`, METHOD.POST, params, { responseType: "blob" });
      }
      this.uploadAboutRequest.requestApi = apiImportPlanOrder;
      this.$refs.importExcelRef.show()
    },
    /** 下载模板操作 */
    handleExportTemplate () {
      const queryData = cloneDeep(this.queryParams)
      queryData.planStatus = this.queryParams?.planStatus?.join(',')
      this.download('scp/scpProductionScheduling/template', {
        ...queryData
      }, `日生产计划成品导入模板_${new Date().getTime()}.xlsx`)
    },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport (fixedPlanType) {
        const queryData = cloneDeep(this.queryParams)
        queryData.planStatus = this.queryParams?.planStatus?.join(',')
        // 五金箱导出固定计划来源为预测需求，其他条件取并集
        if(fixedPlanType === 'wj') { queryData.planType = "FORECAST_DEMAND" }
       const myPagination = this.$refs.dataTable.myPagination
        this.download('scp/scpProductionScheduling/finishProductExport', {
          ...queryData, ...myPagination, pageNum: myPagination.current
        }, `日生产计划(成品)_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record) {
        if (this.currentId && record.orderNumber !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.orderNumber;
      },
      // 编辑-保存
      handleSave (record) {
        apiScpProductionSchedulingFinishProductUpdate(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.onSearch()
            this.isEdit = false;
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 查询快码类型列表
      getLookupList (type, arr) {
        this[arr] = [];
        const lookupQueryParams = { lookupType: type, current: 1, pageSize: 999 }
        this.getLookupListData(lookupQueryParams).then().then(response => {
          this[arr] = response.rows
        })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        const queryData = cloneDeep(this.queryParams)
        queryData.planStatus = this.queryParams?.planStatus?.join(',')
        this.$refs.dataTable.searchParams = queryData;
        this.$refs.dataTable.getData();
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          vendorCode: this.queryParams.vendorCode, // 供应商(林氏产业园清空，其他情况不清空)
          deliveryDateTem: undefined, // 交货时间临时
          deliveryDate1: undefined, // 交货时间起
          deliveryDate2: undefined, // 交货时间结束
          issuedTimeTem: undefined, // 计划单下达时间
          issuedTime1: undefined, // 计划单下达时间1
          issuedTime2: undefined, // 计划单下达时间2
          orderNumber: undefined, // 计划单号
          itemCode: undefined, // 物料编码
          itemName: undefined, // 物料名称
          planStatus: [], // 状态
          planType: undefined // 计划来源
        }
        if(this.organizationCodeOrigin === 'A001') {
          this.queryParams.vendorCode = undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      handleGoSchedulingWorkbench () {
        this.$router.push({ path: '/schedulingWorkbench' })
      },
      // 触发定时任务"签价BOM同步"
      handleSynchronous() {
        this.btnLoading = true
        apiMdmGetSignBom({}).then(res => {
          if (res?.code === 200) {
            this.$message.success(res?.data || '操作成功')
            this.onSearch()
          }
        }).finally(() => {
          this.btnLoading = false
        })
      },
      // 打开物料同步弹窗
      openMaterialSyncModal() {
        this.materialSyncForm = { code: '' }
        this.materialSyncVisible = true
      },
      // 关闭物料同步弹窗
      handleMaterialSyncCancel() {
        this.materialSyncVisible = false
        this.materialSyncForm = { code: '' }
      },
      // 执行物料同步
      handleMaterialSync() {
        this.$refs.materialSyncFormRef.validate(valid => {
          if (valid) {
            this.confirmLoading = true
            apiManualSyncMaterial({ code: this.materialSyncForm.code }).then(res => {
              if (res?.code === 200) {
                this.$message.success('物料同步成功')
                this.materialSyncVisible = false
                this.materialSyncForm = { code: '' }
                this.onSearch()
              } else {
                this.$message.error(res?.msg || '物料同步失败')
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        })
      },
      // 批量取消
      handleBatchCancel() {
        const this_ = this
        this.$confirm({
          title: '提示',
          content: `请确认是否批量取消？`,
          okText: '确定',
          cancelText: '取消',
          onOk () {
            return new Promise((resolve, reject) => {
              // 为空和ISSUED已下发的不可取消，其他状态都可以取消
              const getInitial = this_.selectedRows.filter(item => item.planStatus && item.planStatus !== 'ISSUED')
              if (getInitial?.length > 0) {
                apiScpDelfinishProduct({ orderNos: getInitial.map(val => val.orderNo) }).then(res => {
                  if (res?.code === 200) {
                    this_.$message.success(res?.msg || '操作成功')
                    this_.onSearch()
                  } else {
                    this_.$message.error(`操作失败`)
                  }
                  resolve()
                }).catch((e) => {
                  this_.$message.error(`操作失败`)
                  reject(e)
                })
              } else {
                this_.$message.success('操作成功')
                this_.onSearch()
                resolve()
              }
            })
          }
        })
      },
      // 拆解
      handleDisassemble () {
        const this_ = this
        this.$confirm({
          title: '提示',
          content: `请确认勾选数据是否拆解？`,
          okText: '确定',
          cancelText: '取消',
          onOk () {
            return new Promise((resolve, reject) => {
              apiScpProductionSchedulingDisassembly2({ orderNos: this_.selectedRowKeys }).then(res => {
                if (res?.code === 200) {
                  this_.$message.success(res?.msg || '操作成功')
                  this_.onSearch()
                } else {
                  this_.$message.error(`操作失败`)
                }
                resolve()
              }).catch((e) => {
                this_.$message.error(`操作失败`)
                reject(e)
              })
            })
          },
          onCancel () {
            console.log('取消')
          }
        })
      },
      handleVendorCodeSelectChange (val, selectList, record) {
        const selectedItem = selectList.find(item => item.realValue === val)
        if (selectedItem) {
          record.supplierName = selectedItem.bringOutDataOne
        }
      }
    }
  }
  </script>
  <style scoped lang="less">
  .display-flex {
    display: flex
  }
  .flex1 {
    flex: 1
  }
  .page-header-content {
    /deep/.ant-select {
      width: 100%;
    }
  }
  </style>
